var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIroning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe 1235",
    clipPath: "url(#clip0_321_745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe 1235_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3363",
    d: "M14.1478 8.55481H2.18461C2.05225 8.55481 1.92531 8.60795 1.83171 8.70255C1.73812 8.79715 1.68555 8.92545 1.68555 9.05923C1.6853 9.12554 1.69804 9.19125 1.72303 9.25256C1.74802 9.31388 1.78477 9.36959 1.83116 9.41648C1.92504 9.51092 2.05216 9.56384 2.18461 9.56364H14.1583",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3367",
    d: "M7.52499 12.0732H20.4231C20.5859 12.0733 20.7472 12.0409 20.8977 11.9777C21.0481 11.9146 21.1847 11.822 21.2995 11.7053C21.534 11.4704 21.6667 11.1511 21.6683 10.8175C21.6683 10.4845 21.5378 10.1651 21.3053 9.92919C21.0728 9.69329 20.7573 9.56012 20.4279 9.55884H1.57836C1.41532 9.55857 1.25384 9.59094 1.10325 9.65409C0.952647 9.71723 0.815909 9.8099 0.700931 9.92674C0.468542 10.1625 0.338011 10.4817 0.337891 10.8146C0.337888 11.1475 0.468434 11.4669 0.700931 11.7028C0.933429 11.9387 1.24893 12.0719 1.57836 12.0732H3.26331",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3369",
    d: "M7.5417 17.525H3.2666V9.5531H7.5417V17.525Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3373",
    d: "M3.2666 15.1316H7.54169",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3377",
    d: "M14.1073 9.58395C14.1073 7.07251 13.8085 2.64989 17.1889 0.338867C17.8406 0.781428 18.4027 1.34565 18.8451 2.00123",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3381",
    d: "M19.5059 3.23755C20.4044 5.41109 20.2722 7.91769 20.2722 9.58391",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3405",
    d: "M14.1006 8.25952H20.2781",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3409",
    d: "M11.0023 18.4592L8.81348 20.6715",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3413",
    d: "M7.84866 21.6552L6.25951 23.2604C6.16104 23.36 6.04412 23.439 5.91542 23.4929C5.78673 23.5468 5.64878 23.5746 5.50948 23.5746C5.37017 23.5746 5.23223 23.5468 5.10354 23.4929C4.97484 23.439 4.85792 23.36 4.75945 23.2604C4.6608 23.161 4.58254 23.0428 4.52914 22.9127C4.47574 22.7826 4.44824 22.6432 4.44824 22.5023C4.44824 22.3615 4.47574 22.2221 4.52914 22.092C4.58254 21.9619 4.6608 21.8437 4.75945 21.7443L9.51061 16.9421",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3417",
    d: "M17.3343 12.0634L12.4873 16.9623",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3421",
    d: "M14.341 12.0654L10.9941 15.4482",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3425",
    d: "M7.51172 14.9409L15.7439 23.2613C15.8424 23.3609 15.9593 23.4399 16.088 23.4938C16.2167 23.5477 16.3546 23.5755 16.4939 23.5755C16.6332 23.5755 16.7712 23.5477 16.8999 23.4938C17.0285 23.4399 17.1455 23.3609 17.2439 23.2613C17.3425 23.1618 17.4206 23.0436 17.474 22.9136C17.5273 22.7835 17.5547 22.6441 17.5547 22.5033C17.5547 22.3625 17.5273 22.223 17.474 22.093C17.4206 21.9629 17.3425 21.8447 17.2439 21.7452L7.51172 11.9086",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIroning);
export default __webpack_public_path__ + "static/media/ironing.198492de602c2693ecb459afa40d9148.svg";
export { ForwardRef as ReactComponent };